import { Col, Row, Breadcrumb, Tabs, Modal, message } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { COMMENT_ROUTE } from "shared/constants/routes";
import { CommentTypeConst } from "states/comment/comment.models";
import { CommentTab } from "./components/comment-tab";

export interface ICommentProps { }

export function CommentPage(props: ICommentProps) {
  const [selectedReference, setSelectedReference] = useState<number>();
  const onChangeSelectReference = (selectedReference: number) => {
    setSelectedReference(selectedReference);
  }
  return (
    <div className="comment">
      <Row gutter={[16, 16]}>
        <Col flex="auto">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={COMMENT_ROUTE}>Quản lí bình luân</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Danh sách bình luận</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Tabs type="card" onChange={() => { setSelectedReference(undefined) }} className="mt-4" defaultActiveKey="san-pham">
        <Tabs.TabPane tab="Sản phẩm" key="san-pham" >
          <CommentTab title="sản phẩm" onChangeSelectReference={onChangeSelectReference}
            selectedReference={selectedReference} commentType={CommentTypeConst.ProductDetail}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Danh mục sản phẩm" key="danh-muc-san-pham">
          <CommentTab title="danh mục sản phẩm" onChangeSelectReference={onChangeSelectReference}
            selectedReference={selectedReference} commentType={CommentTypeConst.ProductCate} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Bài viết" key="bai-viet">
          <CommentTab title="bài viết"
            onChangeSelectReference={onChangeSelectReference}
            selectedReference={selectedReference} commentType={CommentTypeConst.BlogDetail} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Trang tĩnh" key="trang-tinh">
          <CommentTab title="trang tĩnh" onChangeSelectReference={onChangeSelectReference}
            selectedReference={selectedReference} commentType={CommentTypeConst.StaticPage} />
        </Tabs.TabPane>
      </Tabs>

    </div>
  );
}
